<div class="main-content background">
    <div class="row style-header">
        <div class="mr-auto xs:mr-0 sm:mr-0 md:mr-0 lg:mr-0 xl:mr-auto col-8 style-title">
            <span>Meu Estoque</span>
        </div>
        <div class="ml-auto xs:ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-auto col-4 style-subtitle">
            <button *ngIf="!inventoryLoading && (!isAssociate || adminAssociate)" class="btn lg:btn-sm xl:btn-sm btn-primary add-button"
                (click)="modalRequestInventory()">
                <i class="material-icons">add</i> Solicitar estoque
            </button>
        </div>
    </div>
    
    <div class="tabs">
        <div class="tabs-header">
            <button class="btn btn-tab" [class.active]="activeTab == 'info'" (click)="changeTab($event)" id="info">
                Câmeras e detecções
            </button>
            <!-- <button class="btn btn-tab" [class.active]="activeTab == 'stock'" (click)="changeTab($event)" id="stock">
                Kits para venda
            </button> -->
        </div>
        <div class="tabs-content" *ngIf="!inventoryLoading && !plansLoading">
            <app-camera-detections-stock *ngIf="activeTab == 'info'"></app-camera-detections-stock>
            <!-- <app-camera-kits-stock [inventory]="inventory" [plans]="plans" *ngIf="activeTab == 'stock'"></app-camera-kits-stock> -->
        </div>
        <div class="tabs-content" *ngIf="inventoryLoading && plansLoading">
            <div class="center-spinner">
                <span nz-icon nzType="loading" nzTheme="outline" style="font-size: 80px"></span>
            </div>
        </div>
    </div>
</div>